import React from 'react';
import type { Aggregates, AreaId } from '../../../types/pulse';
import { followUpResult, followUps } from '../../../data/pulse';
import { alignmentNote, followUpRows } from '../../../utils/pulse';
import { AnswerRecap } from '../AnswerRecap';
import { PeerBars } from '../PeerBars';
import { SERIES } from '../colors';
interface FollowUpResultScreenProps {
  area: AreaId;
  choice: string;
  freeText: string;
  aggregates: Aggregates;
}
export function FollowUpResultScreen({
  area,
  choice,
  freeText,
  aggregates
}: FollowUpResultScreenProps) {
  const block = followUps[area];
  const option = block.options.find(o => o.id === choice);
  const rows = followUpRows(aggregates, area, choice);
  const mine = rows.find(r => r.isMine);
  const isFree = option?.free === true;
  const colors = Object.fromEntries(block.options.map((opt, i) => [opt.id, SERIES[i % SERIES.length]]));
  return <div className="flex flex-1 flex-col" data-id="element-217" data-mp="1xaa0yrsp94al">
      <AnswerRecap lead={followUpResult.lead} value={option?.label ?? ''} note={isFree && freeText.trim() ? freeText.trim() : undefined} data-id="element-218" data-mp="1x8yvmnjlvohd" />

      {isFree ? <p className="mt-4 text-[13px] leading-relaxed text-navy" data-id="element-219" data-mp="17cr2ytz93ns8">{followUpResult.freeTextAck}</p> : <>
          <p className="mt-4 text-[13px] leading-relaxed text-navy" data-id="element-220" data-mp="12jejszdcc96v">
            <span className="font-display text-[22px] font-bold tabular-nums text-blue" data-id="element-221" data-mp="yj48d76s4qkm">
              {mine?.pct ?? 0}%
            </span>{' '}
            of delegates who prioritised {block.peerLead} chose the same.
          </p>
          <p className="mt-2 text-[12.5px] leading-relaxed text-navy2" data-id="element-222" data-mp="oo2nwong8cod">{alignmentNote(rows)}</p>
        </>}

      <p className="mt-6 text-[9px] uppercase tracking-micro text-mut" data-id="element-223" data-mp="fl1jcse8etmt">
        {followUpResult.peerTitle}
      </p>

      <div className="mt-3" data-id="element-224" data-mp="2e163etm95zld">
        <PeerBars rows={rows} colors={colors} data-id="element-225" data-mp="2dzcybirafnfh" />
      </div>
    </div>;
}